export const GRADIENTS = [
  "linear-gradient(120deg, #6E7BFF 0%, #4DD0E1 100%)",
  "linear-gradient(120deg, #FFB870 0%, #FF7E7E 100%)",
  "linear-gradient(120deg, #2E7D62 0%, #80CBA1 100%)",
  "linear-gradient(120deg, #C56CF0 0%, #8E7CF7 100%)",
  "linear-gradient(120deg, #2A8CFF 0%, #6FC6FF 100%)",
  "linear-gradient(120deg, #E1BC59 0%, #B58B23 100%)",
];

function hash(str) {
  let h = 0;
  for (let i = 0; i < str.length; i += 1) {
    h = (h * 31 + str.charCodeAt(i)) >>> 0;
  }
  return h;
}

export function gradientFor(name) {
  if (typeof name !== "string" || name.length === 0) return GRADIENTS[0];
  return GRADIENTS[hash(name) % GRADIENTS.length];
}
